import React from 'react';

// Captura errores de render para que la pantalla no salga en blanco.
// En su lugar muestra el mensaje de error, útil sobre todo en móvil.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // Log para depuración
    console.error('ErrorBoundary capturó:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '1.5rem', maxWidth: 640, margin: '0 auto' }}>
          <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 16, padding: '1rem' }}>
            <h2 style={{ color: '#b91c1c', fontWeight: 700, fontSize: 18, marginBottom: 8 }}>
              Se produjo un error al mostrar esta pantalla
            </h2>
            <p style={{ color: '#7f1d1d', fontSize: 14, marginBottom: 12 }}>
              Puedes volver atrás o recargar. Si el problema sigue, envía este mensaje para revisarlo:
            </p>
            <pre style={{
              background: '#fff', border: '1px solid #fca5a5', borderRadius: 8, padding: '0.75rem',
              fontSize: 12, color: '#991b1b', whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 300, overflow: 'auto'
            }}>
              {String(this.state.error && this.state.error.toString())}
              {this.state.info && this.state.info.componentStack ? '\n' + this.state.info.componentStack : ''}
            </pre>
            <button
              onClick={() => window.location.reload()}
              style={{ marginTop: 12, background: '#6b21a8', color: '#fff', border: 'none', borderRadius: 10, padding: '0.5rem 1rem', fontWeight: 600, cursor: 'pointer' }}>
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
